import { useFetchBiovizSampleSetsQuery } from "@/redux/services/bioviz.api";
import { API_BIOVIZ } from '@/config/env.config';

export const useBiovizStatus = (projectId, sampleSetId) => {

	const { data, isLoading, error } = useFetchBiovizSampleSetsQuery(projectId, { skip: projectId === undefined });
	
	// Return loading state so components can handle it appropriately
	if (isLoading || data === undefined) return { status: false, isLoading: true };
	
	// Handle errors (CORS, network, etc.)
	if (error) return { status: false, isLoading: false };
	
	// Check if projects array exists and has items
	// If projects array is empty, return false; if it has items, return true
	const hasProjects = data?.projects && Array.isArray(data.projects) && data.projects.length > 0;
	
	if (!hasProjects) return { status: false, isLoading: false };

	let href = API_BIOVIZ + `?projectId=${projectId}`;
	if (sampleSetId) href += `&sampleSetId=${sampleSetId}`;

	return { status: true, href, isLoading: false };
};